import { Skeleton, Table, Text } from "@chakra-ui/react";
import React from "react";

export const WithdrawalSkeleton = () => {
  return (
    <Table.ScrollArea
      borderWidth="1px"
      rounded="md"
      maxHeight="70vh"
      width="100%"
    >
      <Table.Root interactive variant="outline" stickyHeader>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeader width="15%">Name</Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Amount
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Currency
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Status
            </Table.ColumnHeader>
            <Table.ColumnHeader width="15%" textAlign="center">
              Transaction ID
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Withdrawal Method
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Withdrawal Date
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Address
            </Table.ColumnHeader>
            <Table.ColumnHeader width="10%" textAlign="center">
              Card
            </Table.ColumnHeader>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Array.from({ length: 10 })?.map((_, index) => (
            <Table.Row key={index}>
              <Table.Cell padding="1rem">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center" fontSize="xs">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
              <Table.Cell textAlign="center">
                <Skeleton asChild loading={true} width="100%" variant="shine">
                  <Text>T</Text>
                </Skeleton>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table.Root>
    </Table.ScrollArea>
  );
};
